import { Injectable } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class BPMService {

    appData: any;

    constructor(
        private httpClient: HttpClient,
        appService: AppService,
    ) {
        this.appData = appService.settings;
    }

    getProcessDetails(processId: string): Observable<any> {
        return this.httpClient.get(
            `${this.appData.webApi}/bpm/processes/${processId}`);
    }

}
